import React, { useEffect } from "react";
import "./privacyTerms.scss";
import { Table } from "antd";
import { Helmet } from "react-helmet";
import MetaTagContents from "../../MetaTagContents";

function Privacy() {
    useEffect(() => {
        window.addEventListener("scroll", () => {
            let elmnt = document.getElementsByClassName("heading-alignment");
            if (elmnt && elmnt[0] && elmnt[0].offsetHeight) {
                let updatedElem =
                    window.document.getElementsByClassName("navbar-light");
                if (updatedElem && updatedElem[0]) {
                    if (window.scrollY > elmnt[0].offsetHeight) {
                        updatedElem[0].classList.add("full-opacity");
                    } else {
                        updatedElem[0].classList.remove("full-opacity");
                    }
                }
            }
        });
    }, []);


    const { name, content } = MetaTagContents.PRIVACY;
    return (
        <body className="terms-and-privacy" style={{ marginTop: "50px" }}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{MetaTagContents.PRIVACY.title}</title>
                <link rel="canonical" href="https://all3d.ai/privacy" />
                <meta name={name} content={content} />
            </Helmet>
            <div className="heading-alignment">
                <h1 className="manrope f-38 w-600 lh-46 black-2b">Privacy Policy</h1>
                <p className="manrope f-24 w-500 lh-32 black-2b">Effective Date: March 31st, 2026</p>
            </div>
            <p className="manrope f-20 w-500 lh-28 grey-73">
                This Privacy Policy (“Policy”) explains how ALL3D (“we,” “our,” or “us”) collects, uses, and protects information related to individuals (“Personal Data”) who use our 3D modeling, AI image generation, 3D CGI and digital experience services (“Services”).
            </p>
            <p className="manrope f-20 w-500 lh-28 grey-73">
                By using our Services, you agree to the collection and use of information in accordance with this Policy. If you do not agree, please discontinue use of the Services.
            </p>

            <br />

            <h2 className="manrope f-20 w-600 lh-28 black-085">1. Overview</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                ALL3D provides 3D modeling, AI image generation, 3D CGI and digital visualization tools powered by both proprietary and open-source artificial intelligence models.
            </p>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                We are committed to respecting your privacy. ALL3D is designed to minimize the collection of directly identifiable personal information. However, certain online identifiers (including Internet Protocol (IP) addresses and device-related data) may be collected where necessary for the operation of the Services or where you have provided explicit consent, as described in this Policy.
            </p>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                To the extent such online identifiers are collected, they may be considered "Personal Data" or "personal information" under applicable laws, including the California Consumer Privacy Act (CCPA/CPRA).
            </p>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                This Policy applies globally to all users.
            </p>

            <br />
            <h2 className="manrope f-20 w-600 lh-28 black-085">2. Scope of this Policy</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                This Policy applies to Personal Data collected when you:
                <br />
                <br />
                <ul>
                    <li>
                        Visit our websites or social media pages.
                    </li>
                    <li>
                        Use our web or mobile applications.
                    </li>
                    <li>
                        Interact with ALL3D representatives via email, phone, or chat.
                    </li>
                    <li>
                        Register for events, webinars, or contests.
                    </li>
                    <li>
                        Use any tools or features that link to this Policy.
                    </li>
                </ul>
                If our Services contain links to other websites or services operated by third parties, their privacy policies govern your interactions there.
            </p>

            <br />

            <h2 className="manrope f-20 w-600 lh-28 black-085">3. Data We Collect</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                We collect limited data necessary to operate our Services efficiently. This includes:
                <br />
                <br />
                <ul>
                    <li>
                        <b>Usage data</b>: Information automatically collected about your interactions with our platform, such as IP address, browser type, device identifiers, and log information.
                    </li>
                    <li>
                        <b>Operational data</b>: 3D model uploads, AI-generated images, textures, and associated metadata required for rendering or processing content.
                    </li>
                    <li>
                        <b>Non-identifiable analytics</b>: Aggregated usage statistics to improve platform performance and AI training.
                    </li>
                </ul>
            </p>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                Where you provide explicit consent through our cookie or privacy preference mechanisms, we and our service providers may also collect additional usage data, including online identifiers (such as IP address), device and browser characteristics, and information regarding your interaction with our website (such as pages viewed, clicks, scrolling behavior, and session activity).
            </p>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                ALL3D does not require users to provide directly identifying personal information (such as names, phone numbers, or billing details) for core use of the Services. Where such information is voluntarily provided by you (e.g., via email or support forms), it will be used solely for the purpose for which it was provided and retained only as long as reasonably necessary.
            </p>

            <br />

            <h2 className="manrope f-20 w-600 lh-28 black-085">4. Use of AI and Training Data</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                ALL3D's AI features use open-source models that are customized and trained using <b>3D models, images, and AI-generated assets</b> created or uploaded through our Services.
            </p>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                By using the Services, you agree that <b>ALL3D may use 3D models, AI images, and related content generated on our platform for AI model training and improvement</b>.
            </p>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                This training data is used only for:
                <br />
                <br />
                <ul>
                    <li>
                        Enhancing model accuracy and creative quality.
                    </li>
                    <li>
                        Improving rendering, lighting, and generative capabilities.
                    </li>
                    <li>
                        Preventing bias, misuse, or duplication.
                    </li>
                </ul>
                ALL3D does not use directly identifiable personal information for AI training.
            </p>

            <br />

            <h2 className="manrope f-20 w-600 lh-28 black-085">5. Cookies and Tracking</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                We use functional and analytical cookies to:
                <br />
                <br />
                <ul>
                    <li>
                        Enable website and application functionality.
                    </li>
                    <li>
                        Measure usage trends and system performance.
                    </li>
                    <li>
                        Provide personalized but non-identifiable experiences.
                    </li>
                </ul>
            </p>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                ALL3D may use analytics and similar technologies to better understand user interactions with our Services. These technologies may collect online identifiers (such as IP address) and usage data.
            </p>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                Such analytics and tracking technologies are only deployed after you provide explicit consent through our cookie consent banner or preference center, except where such technologies are strictly necessary for the operation, security, or integrity of the Services.
            </p>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                You may withdraw or modify your consent at any time through your browser settings or our cookie management tools.
            </p>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                We do <b>not</b> use tracking cookies for targeted advertising or behavioral profiling.
            </p>
            <br />


            <h2 className="manrope f-20 w-600 lh-28 black-085">6. Purpose and Legal Basis for Processing</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                We process data for the following purposes:
                <br />
                <br />
                <ul>
                    <li>
                        To operate and maintain our Services.
                    </li>
                    <li>
                        To secure and protect user content.

                    </li>
                    <li>
                        To improve AI accuracy, performance, and stability.
                    </li>
                    <li>
                        To comply with legal and regulatory obligations.
                    </li>
                </ul>
            </p>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                Where required under applicable law, including the CCPA/CPRA, we rely on user consent for the collection of analytics-related data that is not strictly necessary for the operation of the Services.
            </p>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                All processing is conducted in compliance with GDPR (where applicable), CCPA, and similar global frameworks.
            </p>
            <br />


            <h2 className="manrope f-20 w-600 lh-28 black-085">7. Data Storage and Retention</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                We retain only non-personal, anonymized data for operational continuity and AI model improvement.
            </p>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                Where Personal Data (including online identifiers collected through consent-based analytics) is processed, such data is retained only for as long as reasonably necessary to fulfill the purposes described in this Policy, after which it is deleted or anonymized.
            </p>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                <b>All user content (including 3D models and AI images) is deleted within 30 days of account termination</b>, unless retention is required by law or necessary for ongoing AI model integrity.
            </p>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                ALL3D does not maintain long-term storage of directly identifying personal information.
            </p>
            <br />


            <h2 className="manrope f-20 w-600 lh-28 black-085">8. Sharing and Disclosure</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                We may share limited operational data:
                <br />
                <br />
                <ul>
                    <li>
                        With <b>trusted service providers</b> offering hosting, analytics, or rendering support.
                    </li>
                    <li>
                        With <b>AI model partners</b> (open-source collaborators) for model improvement.
                    </li>
                    <li>
                        With <b>legal authorities</b>, when required by applicable law.
                    </li>

                </ul>
            </p>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                Service providers that process data on our behalf are contractually obligated to use such data solely for the provision of services to ALL3D and not for their own independent purposes.
            </p>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                ALL3D does not sell or share personal information, including for cross-context behavioral advertising.
            </p>
            <br />

            <h2 className="manrope f-20 w-600 lh-28 black-085">9. International Data Transfers</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                We may process and store anonymized data globally, including in the United States and other jurisdictions.
            </p>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                We use appropriate safeguards such as Standard Contractual Clauses (SCCs) and ensure compliance with GDPR and other regional privacy laws.
            </p>
            <br />

            <h2 className="manrope f-20 w-600 lh-28 black-085">10. User Rights</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                Depending on your location, you may have the following rights:
                <br />
                <br />
                <ul>
                    <li>
                        Access to anonymized data associated with your use.
                    </li>
                    <li>
                        Correction or deletion of any content you control.
                    </li>
                    <li>
                        Objection to data processing (where applicable).
                    </li>
                    <li>
                        Withdrawal of consent for AI data usage (note that anonymized training data cannot be retroactively removed once aggregated).
                    </li>

                </ul>
            </p>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                Where applicable under California law, you may also have rights to know, delete, or correct personal information collected about you, subject to certain limitations.
            </p>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                To exercise your rights, contact us at <b>support@all3d.ai</b>.
            </p>
            <br />

            <h2 className="manrope f-20 w-600 lh-28 black-085">11. Data Security</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                We implement strong technical and organizational safeguards, including encryption, secure infrastructure, and limited access protocols.
            </p>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                While no system is completely immune to breaches, we continuously monitor and upgrade our security systems following Apple and Google privacy standards.
            </p>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                Users are responsible for safeguarding their login credentials and session information.
            </p>
            <br />

            <h2 className="manrope f-20 w-600 lh-28 black-085">12. Account Termination and Deletion</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                If an account is terminated or deleted, all related 3D models, AI images, and anonymized usage data are permanently deleted from our systems within <b>30 days</b>.
            </p>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                Any Personal Data collected based on user consent (such as analytics-related data) will also be deleted or anonymized within a reasonable timeframe following termination.
            </p>
            <br />

            <h2 className="manrope f-20 w-600 lh-28 black-085">13. Revenue and Financial Information</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                ALL3D does not store any financial or payment-related PII. Any billing or payment information is processed securely through third-party payment processors that comply with PCI-DSS standards. We do not share, sell, or retain revenue-related data beyond what is required for accounting compliance.
            </p>
            <br />

            <h2 className="manrope f-20 w-600 lh-28 black-085">14. Children's Privacy</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                Our Services are not directed toward children under 13 years of age. We do not knowingly collect data from minors. Parents or guardians who believe a child's data has been provided should contact us immediately for removal.
            </p>
            <br />

            <h2 className="manrope f-20 w-600 lh-28 black-085">15. Updates to this Policy</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                We may update this Policy periodically to reflect new technology, regulatory guidance, or product features. Updates will be communicated through our website and effective upon posting.
            </p>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                The "Effective Date" above will always show the most recent version.
            </p>
            <br />

            <h2 className="manrope f-20 w-600 lh-28 black-085">16. Contact Us</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                If you have any questions about this Privacy Policy or your data rights, contact us at:
                <b> support@all3d.ai</b>
            </p>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                We aim to respond within one month of any legitimate inquiry.

            </p>
            <br />
        </body>
    );
}

export default Privacy;
